import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
// material
import { experimentalStyled as styled } from "@mui/material";
//
import DashboardNavbar, { TOPBAR_DESKTOP, TOPBAR_MOBILE } from "./DashboardNavbar";
import DashboardSidebar, { SIDEBAR_WIDTH } from "./DashboardSidebar";
import BottomNav, { shouldShowBottomNav } from "./BottomNav";
import { MHidden } from "../../components/@material-extend";
import { flexColumn } from "../../utils/MUIShortcuts";

// ----------------------------------------------------------------------

const RootStyle = styled("div")({
  width: "100%",
  height: "100vh",
  overflow: "hidden",
});

const MainStyle = styled("div")(({ theme }) => ({
  ...flexColumn("center", "flex-start"),
  width: "100%",
  height: "100vh",
  overflowY: "scroll",
  overflowX: "hidden",
  overscrollBehaviorX: "none",
  paddingTop: TOPBAR_MOBILE,
  [theme.breakpoints.up("lg")]: {
    paddingTop: TOPBAR_DESKTOP,
    paddingLeft: `${SIDEBAR_WIDTH}px`,
  },
}));

// ----------------------------------------------------------------------

export default function DashboardLayout() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  const showBottomNav = shouldShowBottomNav(pathname);
  const isAdmArea = pathname.startsWith("/adm");

  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  return (
    <RootStyle>
      <DashboardNavbar onOpenSidebar={() => setOpen(true)} />
      <DashboardSidebar isOpenSidebar={open} onCloseSidebar={() => setOpen(false)} />
      <MainStyle
        sx={{
          pb: showBottomNav ? { xs: "calc(76px + env(safe-area-inset-bottom))", md: 0 } : 0,
          // Admin: mobile keeps slim bar offset, desktop has no topbar → pt 0
          // Non-admin: current behaviour (TOPBAR_MOBILE / TOPBAR_DESKTOP)
          pt: isAdmArea
            ? { xs: `${TOPBAR_MOBILE}px`, lg: 0 }
            : { xs: `${TOPBAR_MOBILE}px`, lg: `${TOPBAR_DESKTOP}px` },
        }}
      >
        <Outlet />
      </MainStyle>
      {showBottomNav && (
        <MHidden width="mdUp">
          <BottomNav />
        </MHidden>
      )}
    </RootStyle>
  );
}
